document.addEventListener('DOMContentLoaded', () => {
  const select = document.querySelector('[data-multiselect]')
  const selectWrap = document.querySelector('[data-multiselect-wrap]')
  const selectedContainer = document.querySelector(
    '[data-multiselect-selected]',
  )
  const dropdownList = document.querySelector('[data-multiselect-content]')
  const placeholder = document.querySelector('[data-multiselect-placeholder]')

  const selectItems = []
  const dropdownListItems = []
  const selected = []
  const selectedButtons = []

  const addSelectedButtons = () => {
    if (selected.length > 0) {
      if (placeholder.style.display !== 'none') {
        placeholder.style.display = 'none'
        selectedContainer.style.display = 'flex'
      }

      selectedContainer.innerHTML = selected
        .map(
          (
            item,
          ) => `<button type="button" data-select-tag="" class="button focus-clickable is-variant-tag button-tag">
        <span>${item.text}</span>
        <svg class="svg-sprite-icon">
        <use href="/app/themes/foiv-osp/frontend/dist/images/sprite.symbol.svg#icon-close"></use>
      </svg>
      </button>`,
        )
        .join('')

      selectedButtons.splice(0, selectedButtons.length)

      for (const item of selectedContainer.children) {
        selectedButtons.push(item)
      }

      selectedButtons.forEach((item, index) => {
        item.addEventListener('click', () => {
          const removedButton = selected.splice(index, 1)[0]
          selectItems.push(removedButton)

          if (location.search) {
            window.history.replaceState({}, '', location.pathname)
          }

          for (const item of select.options) {
            if (item.value === removedButton.value) item.selected = false
          }

          select && select.dispatchEvent(new Event('change', { bubbles: true }))

          renderList(selectItems)
        })
      })
    } else {
      if (selectedContainer) selectedContainer.innerHTML = ''
      if (placeholder) placeholder.style.display = 'block'
      if (selectedContainer) selectedContainer.style.display = 'none'
    }
  }

  const renderList = (arr) => {
    dropdownListItems.splice(0, dropdownListItems.length)

    if (dropdownList) {
      dropdownList.innerHTML = arr
        .sort((a, b) => {
          if (a.value < b.value) return -1
          if (a.value > b.value) return 1
          return 0
        })
        .map((item) => {
          return `<div class="select-dropdown-content__item focus-clickable w-full" tabindex="0">
                  <div class="select-dropdown-content__item-text w-full">
                    ${item.text}
                  </div>
                  </div>`
        })
        .join('')
    }

    if (dropdownList) {
      for (const item of dropdownList.children) {
        dropdownListItems.push(item)
      }
    }

    const addSelectedTag = (index) => {
      const selectedOption = selectItems.splice(index, 1)[0]

      selected.push(selectedOption)

      for (const item of select.options) {
        if (item.value === selectedOption.value) item.selected = true
      }

      select && select.dispatchEvent(new Event('change', { bubbles: true }))

      renderList(selectItems)
    }

    dropdownListItems.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        addSelectedTag(index)
      })

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          addSelectedTag(index)
        }
      })

      item.addEventListener('keydown', (e) => {
        if (e.key === 'Backspace') {
          if (dropdownList && !dropdownList.classList.contains('is-visible')) {
            dropdownList.classList.add('is-visible')
          }
        }
      })
    })

    addSelectedButtons()
  }

  if (selectWrap && dropdownList) {
    selectWrap.addEventListener('click', () => {
      dropdownList.classList.remove('is-visible')
    })

    selectWrap.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') dropdownList.classList.remove('is-visible')

      if (event.key === 'Escape') {
        if (dropdownList && !dropdownList.classList.contains('is-visible')) {
          dropdownList.classList.add('is-visible')
        }
      }
    })

    selectWrap.addEventListener('focusin', () => {
      selectWrap.classList.add('focus-clickable')
    })
  }

  if (dropdownList && select) {
    for (const item of select.children) {
      selectItems.push({
        value: item.value,
        text: item.text,
        selected: item.selected,
      })
    }

    selectItems.forEach((item, index) => {
      if (item.selected === true) {
        selected.push(selectItems.splice(index, 1)[0])
      }
    })
  }

  renderList(selectItems)

  document.addEventListener('click', (event) => {
    if (selectWrap) {
      if (!selectWrap.contains(event.target)) {
        dropdownList.classList.add('is-visible')
      }
    }
  })
})
